class V1TutorialTemplete {
    // 1. describe and create/initiate our object.
    constructor() {
        // tutorial content
        this.ele_toggleBtn = document.getElementById("id_toggle_btn");
        this.ele_input = document.getElementById("ru_mySearch");
        var ul = document.getElementById("ru_sidebar_ul");
        this.ele_li = document.getElementsByClassName("ru_sidebar_element");
        // Toggle button 
        this.ru_toggle_btn_id = document.getElementById("ru_toggle_btn_id");
        this.ru_sidebar = document.querySelector('.ru_sidebar');
        this.toggle = document.querySelector('.ru_toggle');
        this.ru_content = document.querySelector('.ru_content');

        this.events();
    }

    // 2. events or dispacher
    events() {
        if(this.ele_input !== null) {
            this.ele_input.addEventListener("keyup", this.sidebar_search.bind(this));
        }
        if(this.ele_toggleBtn !== null) {
            //console.log("this.ele_toggleBtn" + this.ele_toggleBtn);
            this.ele_toggleBtn.addEventListener("click", this.toggleMenu.bind(this));        
        }
    }

    // 3. methods (function, action...)
    sidebar_search() {
        var filter, i, a;
        filter = this.ele_input.value.toUpperCase();
        for (i = 0; i < this.ele_li.length; i++) {            
            a = this.ele_li[i].firstElementChild;            
            if (a.textContent.toUpperCase().indexOf(filter) > -1) {
                this.ele_li[i].style.display = "";
            } else {
               this.ele_li[i].style.display = "none"; 
            }
        }
    }

    toggleMenu() {
        //console.log("toggleMenu Click function called");
        //let ru_toggle_btn_id = document.getElementById("ru_toggle_btn_id");
        this.ru_toggle_btn_id.checked = !this.ru_toggle_btn_id.checked;
        console.log("OnNavExpandClick() <<< " + this.ru_toggle_btn_id.checked);
      
        //let ru_sidebar = document.querySelector('.ru_sidebar');
        //let toggle = document.querySelector('.ru_toggle');
        //let ru_content = document.querySelector('.ru_content');
        //let nav__expand = document.querySelector(".ru_Arrow_btn");
      
        if (this.ru_toggle_btn_id.checked) {
          this.ru_sidebar.classList.add('ru_active');
          this.toggle.classList.add('ru_active');
          this.ru_content.classList.add('ru_active');
          //nav__expand.classList.add("ru_active");
        }
        else {
          this.ru_sidebar.classList.remove('ru_active');
          this.toggle.classList.remove('ru_active');
          this.ru_content.classList.remove('ru_active');
          //nav__expand.classList.remove("ru_active");
        }
      
      }
}
export default V1TutorialTemplete; 